type PartialRegistration = {
  type: 'Individual' | 'Corporate';
  sendId: string;
  firstName?: string;
  lastName?: string;
  businessName?: string;
};

export const getPaymentPreference = <T extends PartialRegistration>(reg: T) => {
  return reg.type === 'Corporate' ? `${reg.sendId} ${reg.businessName}` : `${reg.sendId} ${reg.firstName} ${reg.lastName}`;
};
